import {FC, useEffect, useState} from 'react'
import {connect, ConnectedProps} from 'react-redux'
import {LayoutSplashScreen} from '../../../../_metronic/layout/core'
import * as client from './ClientRedux'
import {RootState} from '../../../../setup'

const mapState = (state: RootState) => ({client: state.client})
const connector = connect(mapState, client.actions)
type PropsFromRedux = ConnectedProps<typeof connector>

const ClientInit: FC<PropsFromRedux> = (props) => {
  const [showSplashScreen, setShowSplashScreen] = useState(true)

  // We should request user by authToken before rendering the application
  useEffect(() => {}, [])

  return showSplashScreen ? <LayoutSplashScreen /> : <>{props.children}</>
}

export default connector(ClientInit)
